import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { BannerStatus } from 'ui-components/components/banner-message/banner-enums';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';

import messages from '../messages';

const ErrorBanner = ({ isError = false }) => {
  if (!isError) {
    return null;
  }

  return <BannerMessageV2 content={<FormattedMessage {...messages.errorBannerText} />} status={BannerStatus.Error} />;
};

ErrorBanner.propTypes = {
  isError: PropTypes.bool,
};

export { ErrorBanner };
